var map = {
  "./da.json": [
    "96454",
    [
      93995
    ]
  ],
  "./fi.json": [
    "80132",
    [
      93701
    ]
  ],
  "./sv.json": [
    "99288",
    [
      49889
    ]
  ],
  "./ja.json": [
    "75680",
    [
      10457
    ]
  ],
  "./lt.json": [
    "72989",
    [
      44654
    ]
  ],
  "./sl.json": [
    "44002",
    [
      84959
    ]
  ],
  "./fr.json": [
    "56041",
    [
      76914
    ]
  ],
  "./es.json": [
    "42241",
    [
      79994
    ]
  ],
  "./no.json": [
    "21218",
    [
      94079
    ]
  ],
  "./cs.json": [
    "49111",
    [
      57596
    ]
  ],
  "./en.json": [
    "73250",
    [
      21951
    ]
  ],
  "./description/en.json": [
    "83225",
    [
      43298
    ]
  ],
  "./pl.json": [
    "51617",
    [
      80058
    ]
  ],
  "./hu.json": [
    "73830",
    [
      19531
    ]
  ],
  "./nl.json": [
    "55475",
    [
      97200
    ]
  ],
  "./de.json": [
    "91658",
    [
      91767
    ]
  ],
  "./pt.json": [
    "51321",
    [
      67778
    ]
  ],
  "./it.json": [
    "67492",
    [
      85765
    ]
  ],
  "./et.json": [
    "78008",
    [
      74977
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 64064;
module.exports = __rspack_async_context;
